export default "__VITE_ASSET__71a00b2e__"